import { create } from 'zustand';

type ChargingState = {
  ongoingChargingSession: string;
  expectingChargingReceipt: boolean;
};

type ChargingActions = {
  setOngoingChargingSession: (chargingSessionId: string) => void;
  setExpectingChargingReceipt: (expecting: boolean) => void;
};

export const useChargingStore = create<ChargingState & ChargingActions>()(
  (set) => ({
    ongoingChargingSession: '',
    expectingChargingReceipt: false,
    setOngoingChargingSession: (chargingSessionId) =>
      set({ ongoingChargingSession: chargingSessionId }),
    setExpectingChargingReceipt: (expecting) =>
      set({ expectingChargingReceipt: expecting }),
  })
);
